// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal_closeButton__1AY8u {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 18px;\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://src/components/Modal/modal.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AADF","sourcesContent":["@import \"../../assets/scss/variables\";\n\n.closeButton {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 18px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "modal_closeButton__1AY8u"
};
export default ___CSS_LOADER_EXPORT___;
